<template>
  <div class="outmain heighthv pad_20 bor_rad5 ba_f">
    <!-- <div class="pagetitle mar_b20">等级列表</div> -->
    <div class="shuju_title mar_b20">
      <div class="shuju_title_text">
        <span>骑手等级列表</span>
      </div>
    </div>
    <div class="flex-bet mar_b20">
      <div class="t_l">
        <el-button type="primary" size="medium" @click="handleEdit(false)">新增等级</el-button>
      </div>
    </div>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
      <el-table-column type="selection" width="55"></el-table-column>
      <!-- <el-table-column prop="id" label="ID"></el-table-column> -->
      <el-table-column prop="level" label="骑手等级" align="center">
        <template slot-scope="scope">{{ scope.row.level }}�</template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('rider.level.levelTitle')" align="center"></el-table-column>
      <el-table-column prop="icon" label="等级图标" align="center">
        <template slot-scope="scope">
          <div class="imgbox">
            <img :src="scope.row.icon" class="tabimg" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receiptNum" :label="$t('rider.level.dailyMerge')" align="center">
        <template slot-scope="scope">
          <div class="flex flex-justify-center">
            <section class="debug-d debug-small" style="background: #2a75ed;"></section>
            <span class="minWidth">{{ scope.row.receiptNum }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="transferNum" :label="$t('rider.level.dailyTransfer')" align="center">
        <template slot-scope="scope">
          <div class="flex flex-justify-center">
            <section class="debug-d debug-small" style="background: #fd5500;"></section>
            <span class="minWidth">{{ scope.row.transferNum }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cancelNum" :label="$t('rider.level.dailyCancel')" align="center">
        <template slot-scope="scope">
          <div class="flex flex-justify-center">
            <section class="debug-d debug-small" style="background: #67c23a;"></section>
            <span class="minWidth">{{ scope.row.cancelNum }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ratio" :label="$t('rider.level.commissionRatio')" align="center">
        <template slot-scope="scope">{{ scope.row.ratio + '%' }}</template>
      </el-table-column>
      <el-table-column prop="upgradeNum" :label="$t('rider.level.upgradeCondition')" align="center"></el-table-column>
      <el-table-column prop="riderNum" :label="$t('rider.level.riderCount')" align="center">
        <template slot-scope="scope">
          <div class="curs" @click="openInfo(scope.row.id)">
            <span class="mar_r10" style="color: #67c23a;">{{ scope.row.riderNum }}</span>
            <i class="el-icon-zoom-in"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="添加时间" align="center"></el-table-column>
      <el-table-column :label="$t('common.operation')" align="center" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row.id)">{{ $t('common.edit') }}</el-button>
          <el-button type="text" @click="handleDelete(scope.row.id)">{{ $t('common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
    <edit ref="edit" @fetchData="fetchData"></edit>
    <el-dialog title="人数详情" :visible="dialogTableVisible" @close="closeDia">
      <el-table :data="gridData">
        <el-table-column property="userName" label="昵称"></el-table-column>
        <el-table-column property="realName" :label="$t('rider.list.name')"></el-table-column>
        <el-table-column property="orderNum" :label="$t('common.status')"</el-table-column>
        <el-table-column property="createdAt" label="注册时间"></el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="page_1.total" :page-size="page_1.size" :current-page="page_1.currentPage" @current-change="levelListChange"></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './components/edit';
import { levelList, gradeDel, getCurlevelNum } from '@/api/rider';
export default {
  components: { Edit },
  data() {
    return {
      dialogTableVisible: false,
      options: [
        {
          value: '0',
          label: '',
        },
        {
          value: '1',
          label: '',
        },
        {
          value: '2',
          label: '',
        },
        {
          value: '3',
          label: '',
        }
      ],
      value: '',
      list: [],
      listLoading: true,
      selectRows: '',
      
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      },
      gridData: [],
      page_1: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  created() {
    this.fetchData();
  },
  computed: {

    loadingText() {

      return this.$t('common.loading');

    },

  },

  methods: {
    closeDia() {
      this.dialogTableVisible = false;
    },
    openInfo(id) {
      if (id) {
        this.page_1.levelId = id;
      }
      getCurlevelNum(this.page_1).then((res) => {
        if (res.code == 1) {
          this.gridData = res.data;
          this.page_1.total = res.count;
          this.dialogTableVisible = true;
        }
      });
    },
    levelListChange(msg) {
      this.page_1.page = msg;
      this.openInfo();
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleEdit(id) {
      this.$refs['edit'].showEdit(id);
    },
    async fetchData() {
      var params = {
        page: this.page.currentPage
      };
      const { data, count } = await levelList(params);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
    handleDelete(id) {
      gradeDel({ id: id }).then((res) => {
        if (res.code == 1) {
          this.$baseMessage(res.msg, 'success');
          this.fetchData();
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.minWidth {
  min-width: 60px;
  text-align: justify;
}
</style>
